import { render, staticRenderFns } from "./QuotaMonthRatio.vue?vue&type=template&id=6846764d&scoped=true&"
import script from "./QuotaMonthRatio.vue?vue&type=script&lang=js&"
export * from "./QuotaMonthRatio.vue?vue&type=script&lang=js&"
import style0 from "./QuotaMonthRatio.vue?vue&type=style&index=0&id=6846764d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6846764d",
  null
  
)

export default component.exports